export default "__VITE_ASSET__BGSf2ne6__"